import request from '@utils/request'

export function fetchOptionsets(params) {
  return request({
    url: `/admin/optionset`,
    params,
  })
}

export function fetchOptionset(seq) {
  return request({
    url: `/admin/optionset/${seq || 0}`,
    method: 'get',
  })
}

export function createOptionset(data) {
  return request.post('/admin/optionset', data)
}

export function updateOptionset(data) {
  return request.put(`/admin/optionset/${data.seq}`, data)
}

export function deleteOptionset(seq) {
  return request.delete(`/admin/optionset/${seq}`)
}

export function fetchOptions(optionset_seq) {
  return request({
    url: `/admin/optionset/${optionset_seq || 0}/option`,
  })
}

export function fetchOption(optionset_seq, seq) {
  return request({
    url: `/admin/optionset/${optionset_seq || 0}/option/${seq || 0}`,
    method: 'get',
  })
}

export function createOption({ optionset_seq, ...data }) {
  return request.post(`/admin/optionset/${optionset_seq || 0}/option/`, data)
}

export function updateOption({ optionset_seq, seq, ...data }) {
  return request.put(
    `/admin/optionset/${optionset_seq || 0}/option/${seq}`,
    data
  )
}

export function deleteOption(optionset_seq, seq) {
  return request.delete(`/admin/optionset/${optionset_seq || 0}/option/${seq}`)
}
